
<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Stock</h6>
        <div class="row">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Item</label>
                <select class="form-control" v-model="search.item">
                    <option v-for="(itemObj,index) in stockItem" :key="index" :value="itemObj.item">
                        {{ itemObj.item }} - {{ itemObj.supplier }}
                    </option>
                </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date From</label>
                <input type="date" id="input_datefrom" class="form-control" v-model="search.datefrom">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date To</label>
                <input type="date" id="input_dateto" class="form-control" v-model="search.dateto">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success " style="float:right;" id="btn_search" @click="getStockList">Search</button>
            </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Item
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Stock In
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Stock Out
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Details
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Date
                </th>
                <th class="text-secondary opacity-7"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in paginatedStock" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ item.item }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        User: {{ item.usedby}}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <h5 class="text-xs font-weight-bold mb-0">{{ item.stockin }} Tong/Beg</h5>
                </td>
                <td>
                  <h5 class="text-xs font-weight-bold mb-0">{{ item.stockout }} Tong/Beg</h5>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">Capacity: {{ item.capacity }}</p>
                  <p class="text-xs font-weight-bold mb-0">Remark: {{ item.remark }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ item.created_at }}</p>
                </td>
                <td class="align-middle">
                  <RouterLink :to="{path : '/editSawitBuah/'+ item.stockid}"
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit Sawit Buah"
                    >Edit
                  </RouterLink>
                </td>
              </tr>
              
            </tbody>
          </table>
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'stockSelect',
  data(){
    return {
      totalRows: 0,
      currentPage: 0,
      perPage: 10,
      searchQuery:'',
      stocklist: [],
      stockItem:[],
      search:{
          dateto: new Date().toISOString().slice(0,10),
          datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
          item: '',
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.stocklist.length / this.perPage);
    },
    paginatedStock() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.stocklist.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getStockList();
    this.listAllStockProfile();
  },
  methods: {

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getStockList(){
      var item = '%';
        if(this.search.item != ''){
            item = this.search.item;
        }
        // console.log('stock/listAllStock/' + this.search.datefrom + "/" + this.search.dateto + "/" +  item);
        axios.get('stock/listAllStock/' + this.search.datefrom + "/" + this.search.dateto + "/" +  item)
            .then(res => {
              console.log(res.data.stocklist);
              this.stocklist = res.data.stocklist;
              this.totalRows = res.data.stocklist.length;
              this.currentPage = 1;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    listAllStockProfile(){
        this.blockList = [];
        axios.get('stock/listAllStockProfile')
            .then(res => {
                this.stockItem = res.data.stockprofile;
                this.search.item = res.data.stockprofile[0].item;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
  },
}
</script>
  